import {
    GET_LIST,
    DETAIL,
    RECIPIENT_LIST,
    CREATE,
    UPDATE,
    DELETE
} from "../../api/wake-up-call";
import querystring from "query-string";

const state = {
    list: [],
    detail: {},
    source_type: [{
        id: 'LINK',
        label: 'Link / URL'
    },{
        id: 'FILE',
        label: 'Attachment File'
    }],
    scheduling: [{
        id: 'NOW',
        label: 'Now (One time notification)',
        selectable: true
    },{
        id: 'SCHEDULED',
        label: 'Scheduled (One time notification)',
        selectable: false
    },{
        id: 'DAILY',
        label: 'Daily (Recurring notifications)',
        selectable: false
    },{
        id: 'CUSTOM',
        label: 'Custom (Recurring notifications)',
        selectable: false
    }],
    target_type: [{
        id: 'PERSON',
        label: 'Person'
    },{
        id: 'Area',
        label: 'Area'
    }],
    columns: [
        {
            label: "Title",
            field: "title",
        },
        {
            label: "Description",
            field: "description",
        },
        {
            label: "Audio",
            field: "source_path",
            sortable: false
        },
        {
            label: "Status",
            field: "status",
        },
        {
            label: "Action",
            field: "action",
            sortable: false
        },
    ],
    recipient: [
        {
            label: "NIK",
            field: "nik",
        },
        {
            label: "Fullname",
            field: "fullname",
        },
        {
            label: "Status",
            field: "status",
        },
        {
            label: "Sent At",
            field: "sent_at",
            sortable: false
        },
        {
            label: "Target Type",
            field: "target_type",
            sortable: false
        },
        {
            label: "Played At",
            field: "played_at",
            sortable: false
        },
        {
            label: "Finished At",
            field: "finished_at",
            sortable: false
        }
    ],
    recipients: [],
};
const mutations = {
    SET_LIST: (state, payload) => {
        state.list = payload;
    },
    SET_DETAIL: (state, payload) => {
        payload["area"] = payload["area"];
        state.detail = payload;
    },
    SET_RECIPIENT: (state, payload) => {
        state.recipients = payload;
    },
};
const actions = {
    GET_LIST: async ({ commit }, params) => {
        params = querystring.stringify(params);
        const resp = await GET_LIST(params);
        const data = resp.data.data;
        commit("SET_LIST", data);
    },
    DETAIL: async ({ commit }, args) => {
        const resp = await DETAIL(args.id);
        const data = resp.data.data;
        commit("SET_DETAIL", data);
    },
    GET_RECIPIENT: async ({ commit }, params) => {
        params = querystring.stringify(params);
        const resp = await RECIPIENT_LIST(params);
        const data = resp.data.data;
        commit("SET_RECIPIENT", data);
    },
    CREATE: async ({ commit }, args) => {
        return await CREATE(args);
    },
    UPDATE: async ({ }, args) => {
        await UPDATE(args);
    },
    DELETE: async ({ commit }, args) => {
        await DELETE(args.id);
    },
};
const getters = {
    list: (state) => state.list,
    detail: (state) => state.detail,
    recipient: (state) => state.recipient,
    recipients: (state) => state.recipients,
    columns: (state) => state.columns,
    source_type: (state) => state.source_type,
    scheduling: (state) => state.scheduling,
    target_type: (state) => state.target_type
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
};
